<template>
  <div class="query-topic">
    <loader_component v-if="is_loading" />
    <div v-else>
      <div class="mb-2 d-flex align-items-center">
        <span class="font-weight-bolder"> Query: </span>
        <span class="ml-auto clickable hoverable" @click="copyQuery" v-if="query">
          {{ is_copy ? "Berhasil Disalin!" : "Salin" }}
          <i class="bi bi-copy" aria-hidden="true"></i>
        </span>
      </div>
      <div class="border rounded p-2" style="max-height: 20rem; overflow: auto"
        v-html="query ? emphasizeORWithStrong(query) : 'Tidak ada Query'"></div>
    </div>
  </div>
</template>
<script>
import loader_component from "../../loader.vue";

export default {
  name: "modal_query_topic",
  components: {
    loader_component,
  },
  data() {
    return {
      is_loading: true,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : atob(this.$route.query.ref),
      data: this.$parent.data,
      query: null,
      is_copy: false,
    };
  },
  methods: {
    emphasizeORWithStrong: function (text) {
      var emphasizedText = text.replace(/( OR )/gi, "<strong>$1</strong>");
      return emphasizedText;
    },
    getQuery() {
      this.is_loading = true;
      const api = `${process.env.VUE_APP_API_URL}query-topic/${this.id_project}?id_topic=${this.data.id}&tipe=${this.data.tipe}`;
      this.$http
        .get(api)
        .then((res) => {
          this.query = res.data.query_topic;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    copyQuery() {
      /* Secure Method (https) */
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.query ?? "Maaf Clip Board Tidak Berfungsi").then(() => {
          console.log('Success to copy text: ', this.query);
          this.is_copy = true;
          setTimeout(() => {
            this.is_copy = false;
          }, 3000);
        }).catch(err => {
          console.log('Failed to copy text: ', err);
        })
      }
      /* unSecure Method (http) */
      else {
        // Create a temporary textarea element
        const textarea = document.createElement('textarea');
        textarea.value = this.query || "Maaf Clip Board Tidak Berfungsi";
        console.log(textarea.value)

        // Make the textarea invisible
        textarea.style.position = 'fixed'; // Prevent scrolling to the bottom of the page in MS Edge.
        textarea.style.opacity = '0';
        textarea.style.pointerEvents = 'none'; // Ensure it doesn't interfere with user interaction

        // Append the textarea to the body
        document.body.appendChild(textarea);

        // Select the text
        // textarea.focus();
        textarea.select();

        try {
          const successful = document.execCommand('copy');
          if (successful) {
            this.is_copy = true;
            console.log('Text copied to clipboard');
            setTimeout(() => {
              this.is_copy = false;
            }, 3000);
          } else {
            console.error('Failed to copy text');
          }
        } catch (err) {
          console.error('Error copying text: ', err);
        } finally {
          // Remove the textarea from the document
          document.body.removeChild(textarea);
        }
      }
    },
  },
  created() {
    this.getQuery();
  },
};
</script>